/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AgentWhoamiRequest} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_whoami_messages.pb'
import {AgentWhoamiResponse} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_whoami_messages.pb'


export const agentWhoami = (request: AgentWhoamiRequest, options?: CashRequestOptions) => post<AgentWhoamiRequest, AgentWhoamiResponse>("/2.0/cash/agent-whoami", request, {...options, rejectOnError: true })